import { render, staticRenderFns } from "./PromiseComponent.vue?vue&type=template&id=129db890&scoped=true&"
import script from "./PromiseComponent.vue?vue&type=script&lang=ts&"
export * from "./PromiseComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PromiseComponent.vue?vue&type=style&index=0&id=129db890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129db890",
  null
  
)

export default component.exports